import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, FieldArray, change, getFormValues, formValueSelector } from 'redux-form';
import { isEmpty, isEqual } from 'lodash';
import { compose } from 'redux';
import { Form } from 'react-bootstrap';
import CollectionContentTable from './CollectionContentTable';
import FormFeedback from '../../../../../shared/components/formComponents/FormFeedback';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';

class CollectionContentForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTrackId: '',
            selectedTrack: {},
            additionalContent: {} // keeps track of assets added to ContentIds field
        };
    }

    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        submitSucceeded: PropTypes.bool,
        submitFailed: PropTypes.bool,
        onCancel: PropTypes.func,
        submitting: PropTypes.bool,
        error: PropTypes.string,
        learningAssetsById: PropTypes.object,
        behaviorsById: PropTypes.object,
        initialValues: PropTypes.object,
        currentValues: PropTypes.object,
        mediaMetadata: PropTypes.array,
        onSubmit: PropTypes.func,
        changeFormValue: PropTypes.func,
        getFormFieldValue: PropTypes.func,
        history: PropTypes.object,
    };

    /**
     *
     * @param {Object} selectedObject
     * @param {string} selectedObject._id
     * @private
     */
    handleLearningAssetChange = (selectedObject) => {
        this.setState({
            selectedTrackId: selectedObject._id,
            selectedTrack: selectedObject
        });
    };

    toggleLearningAssetLock = (values, index) => {
        const { changeFormValue, currentValues } = this.props;
        const { additionalContent } = this.state;

        const valueToSet = !(values.isLocked === true);

        const contentArray = (currentValues && currentValues.contentIds) || [];
        contentArray[index] = {
            ...contentArray[index],
            isLocked: valueToSet
        };

        if (!isEmpty(additionalContent[values.id])) {
            this.setState({
                additionalContent: {
                    ...additionalContent,
                    [values.id]: {
                        ...additionalContent[values.id],
                        isLocked: !additionalContent[values.id].isLocked
                    }
                }
            });
        }

        return changeFormValue({
            field: 'contentIds',
            value: contentArray
        });
    };

    handleContentAddition = (newAsset) => {
        this.setState({
            additionalContent: {
                ...this.state.additionalContent,
                [newAsset.id]: newAsset
            },
            selectedTrack: {},
            selectedTrackId: ''
        });
    };

    handleContentRemoval = (removedAsset) => {
        if (!isEmpty(this.state.additionalContent[removedAsset.id])) {
            const updatedAdditionalContent = {
                ...this.state.additionalContent
            };
            delete updatedAdditionalContent[removedAsset.id];
            this.setState({
                additionalContent: updatedAdditionalContent
            });
        }
    };

    _makeSaveButtonClickHandler = () => {
        const { handleSubmit, onSubmit, currentValues, initialValues } = this.props;

        const isReorderOnly =
            !isEqual(initialValues?.contentIds, currentValues?.contentIds) &&
            [...new Set([...(initialValues?.contentIds || []), ...(currentValues?.contentIds || [])])].length ===
                initialValues.contentIds?.length;

        return handleSubmit((values) =>
            onSubmit({
                values,
                options: { isReorderOnly }
            })
        );
    };

    render() {
        const {
            submitting,
            onCancel,
            error,
            learningAssetsById,
            getFormFieldValue,
            behaviorsById,
            currentValues = {},
            history
        } = this.props;
        const { selectedTrackId, selectedTrack } = this.state;
        return (
            <Form inline className={'collection-form'}>
                <FieldArray
                    name={'contentIds'}
                    learningAssetsById={learningAssetsById}
                    label={'Activities'}
                    currentValues={currentValues}
                    selectedTrackId={selectedTrackId}
                    selectedTrack={selectedTrack}
                    handleLearningAssetChange={this.handleLearningAssetChange}
                    toggleLearningAssetLock={this.toggleLearningAssetLock}
                    history={history}
                    component={CollectionContentTable}
                    handleContentAddition={this.handleContentAddition}
                    handleContentRemoval={this.handleContentRemoval}
                    behaviorsById={behaviorsById}
                    getFormFieldValue={getFormFieldValue}
                />
                <br />
                <div className={'row'}>
                    <div className={'col-12 formButtons'}>
                        <VerbButton
                            fontAwesomeIcon={'fa-save'}
                            textId={'BUTTON_SAVE'}
                            defaultMessage={'SAVE'}
                            onClick={this._makeSaveButtonClickHandler()}
                            disabled={submitting}
                        />
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            fontAwesomeIcon={'fa-ban'}
                            textId={'BUTTON_CANCEL'}
                            defaultMessage={'CANCEL'}
                            onClick={onCancel}
                            disabled={submitting}
                        />
                    </div>
                    <FormFeedback failMsg={error} className={'col-12'} {...this.props} />
                </div>
            </Form>
        );
    }
}

export const CollectionContentFormComponent = CollectionContentForm;
export const makeMapStateToProps = () => {
    const mapStateToProps = (state, ownProps) => {
        const { learningAssets, behaviors } = state;
        const { contentIds, resources, isContentProgressionLocked = true } = ownProps.currentCollection;
        let initialValues = {
            contentIds,
            resources,
            isContentProgressionLocked
        };

        if (ownProps.copiedCollection) {
            initialValues = { ...ownProps.copiedCollection };
        }
        return {
            getFormFieldValue: (fieldName) => formValueSelector('Collection')(state, fieldName),
            currentValues: getFormValues('Collection')(state),
            behaviorsById: behaviors.byId,
            learningAssetsById: learningAssets.byId,
            initialValues
        };
    };

    return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    changeFormValue: (params) => dispatch(change('Collection', params.field, params.value))
});

const CollectionContentFormValidation = {
    form: 'Collection',
    destroyOnUnmount: false,
    enableReinitialize: true
};
export default compose(
    connect(makeMapStateToProps, mapDispatchToProps),
    reduxForm(CollectionContentFormValidation)
)(CollectionContentForm);
